module.exports = __webpack_public_path__ + "static/img/6_bc_coca-i.2a286bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6_bc_coca-i.png
// module id = bmcA
// module chunks = 0